<template>
  <div class="main_in">
    <header-view></header-view>
    <nav-view></nav-view>
    <main>
      <span id="ContentSkipLink" tabindex="-1" class="sr-only">main content</span>
      <router-view/>
    </main>
    <footer-view></footer-view>
  </div>
</template>
<script>
import HeaderView from "@/components/Header/Header";
import NavView from "@/components/Nav/Nav";
import FooterView from "@/components/Footer/Footer";
export default {
  components: {
    HeaderView,
    NavView,
    FooterView
  },
  name: "EntryPage",
  data() {
    return {
      
    };
  },
  props: {},
  watch: {},
  methods: {},
  filters: {},
  computed: {},
  created() {
   
  },
  mounted() {
    
  },
  destroyed() {}
};
</script>
<style lang="less">

</style>
